// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'documents';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M16 15.2a.812.812 0 0 1-.23.566.785.785 0 0 1-.556.234H5.786c-.209 0-.409-.084-.556-.234S5 15.412 5 15.2V4.8a.813.813 0 0 1 .23-.566A.785.785 0 0 1 5.786 4h7.857c.205 0 .402.082.548.228l1.572 1.537a.8.8 0 0 1 .237.573zM11 2H3m0 12s-.656.035-.85-.2C1.956 13.565 2 13 2 13M3 2.006s-.656-.035-.85.2c-.194.235-.15.8-.15.8M2 3v10'
  />
);

export const viewBox = '0 0 18 18';
